// 全站標籤
import Link from "next/link";

const Tag = ({ tag, onClick = null, location = null }) => {
  return (
    <Link
      target="_blank"
      rel="noopener"
      className={`tag ${/[\u4e00-\u9fa5]/.test(tag) ? "" : "!font-[200]"}`}
      href={`/search/${tag}${location === "project" ? "?type=project" : ""}`}
      onClick={onClick}
      prefetch={false}
    >
      {tag}
    </Link>
  );
};

export default Tag;
